module.exports = __webpack_public_path__ + "img/kx5600-char-5.a68d39eb.png";